import { Button, Grid, Typography } from "@mui/material";

import AlertModal from "components/AlertModal";
import NumberFormats from "components/NumberFormats";
import React from "react";
import { SpaceBetweenBox } from "components/GeneralStyled";
import { TRADE_SIDE } from "pages/BasicTrade/components/constants";
import { useSelector } from "react-redux";

function CompleteConvertModal({ open, onClose }) {
  const convertInsertConfirmedUser = useSelector(
    (state) => state.convert.convertInsertConfirmedUser?.data
  );

  return (
    <AlertModal open={open} onClose={onClose} variant="success">
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h4" fontWeight={700} textAlign="center">
            Success
          </Typography>

          <Typography
            textAlign="center"
            variant="subtitle1"
            color={
              convertInsertConfirmedUser?.sideId === TRADE_SIDE.Buy.id
                ? "success.main"
                : "error.main"
            }
            pb={1}
          >
            {convertInsertConfirmedUser?.side}{" "}
            {convertInsertConfirmedUser?.type}
          </Typography>
        </Grid>
        <Grid xs={12}>
          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="subtitle1">
              Amount
            </Typography>

            <Typography textAlign="end">
              <Typography component="b" color="text.main" variant="h6">
                <NumberFormats value={convertInsertConfirmedUser?.filled} />
              </Typography>{" "}
              <Typography
                variant="subtitle2"
                color="text.secondary"
                component="small"
              >
                {" "}
                {convertInsertConfirmedUser?.coinSourceName}
              </Typography>
            </Typography>
          </SpaceBetweenBox>

          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="subtitle1">
              Fee
            </Typography>

            <Typography flex="0 0 60%" textAlign="end">
              <Typography component="b" variant="h6" color="text.main">
                <NumberFormats value={convertInsertConfirmedUser?.fee} />{" "}
              </Typography>{" "}
              <Typography
                variant="subtitle2"
                color="text.secondary"
                component="small"
              >
                {convertInsertConfirmedUser?.coinFeeName}
              </Typography>
            </Typography>
          </SpaceBetweenBox>

          <SpaceBetweenBox>
            <Typography color="text.secondary" variant="subtitle1">
              Total
            </Typography>

            <Typography textAlign="end">
              <Typography component="b" variant="h6" color="text.main">
                <NumberFormats value={convertInsertConfirmedUser?.total} />{" "}
              </Typography>

              <Typography
                variant="subtitle2"
                color="text.secondary"
                component="small"
              >
                {" "}
                {convertInsertConfirmedUser?.coinDestinationName}
              </Typography>
            </Typography>
          </SpaceBetweenBox>
        </Grid>
        <Grid item xs={12} mt={2}>
          <Button fullWidth onClick={onClose} color="success">
            بازگشت
          </Button>
        </Grid>
      </Grid>
    </AlertModal>
  );
}

export default CompleteConvertModal;
